import { GetterTree } from 'vuex';
import { SchedulesState } from '@/store/schedules/types';
import { RootState } from '@/store/types';
import _ from 'lodash';

const getters : GetterTree<SchedulesState, RootState> = {
  /**
   * スケジュールIDを元にスケジュールを取得する
   * @param {string} id スケジュールID
   */
  getScheduleById: (state) => (id: string) => _.find(state.schedules, { id }),
};

export default getters;
